import { component } from 'picoapp';
import Countdown from 'utils/countdown';

export default component((node) => {
  const { timer } = node.dataset;

  // eslint-disable-next-line no-new
  new Countdown(node, {
    endDate: timer,
  });
});
